import Document from "../../../models/document";

interface VersionsModalProps {
  show: boolean;
  selectedDocument: Document | null;
  documentVersions: any[];
  versionsLoading: boolean;
  onClose: () => void;
  onDownloadVersion: (versionId: string) => void;
}

const VersionsModal: React.FC<VersionsModalProps> = ({
  show,
  selectedDocument,
  documentVersions,
  versionsLoading,
  onClose,
  onDownloadVersion,
}) => {
  if (!show) {
    return null;
  }

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1050,
      }}
    >
      <div
        className="modal-dialog modal-lg"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          margin: 0,
        }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Versiones del Documento: {selectedDocument?.name}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            {versionsLoading ? (
              <div className="text-center p-3">
                <i className="fa fa-spinner fa-spin fa-2x"></i>
                <p className="mt-2">Cargando versiones...</p>
              </div>
            ) : documentVersions.length === 0 ? (
              <div className="text-center p-3">
                <p>No hay versiones disponibles para este documento.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Nombre</th>
                      <th>Nombre anterior</th>
                      <th>Archivo</th>
                      <th>Fecha</th>
                      <th>Usuario</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentVersions.map((version: any) => {
                      const canDownload = Boolean(version.version);
                      const changeTypeLabel =
                        version.changeType === "name_changed"
                          ? "Nombre actualizado"
                          : version.changeType === "file_removed"
                          ? "Archivo eliminado"
                          : "Archivo actualizado";

                      return (
                        <tr key={version.id}>
                          <td>{changeTypeLabel}</td>
                          <td>{version.documentName || selectedDocument?.name}</td>
                          <td>{version.previousDocumentName || "-"}</td>
                          <td>{version.filePath || "-"}</td>
                          <td>
                            {version.createdAt
                              ? new Date(version.createdAt).toLocaleString(
                                  "es-ES"
                                )
                              : "N/A"}
                          </td>
                          <td>{version.createdByEmail || "-"}</td>
                          <td>
                            <button
                              className="btn btn-outline-primary btn-sm"
                              onClick={() => onDownloadVersion(version.version)}
                              disabled={!canDownload}
                              title={
                                canDownload
                                  ? "Descargar esta versión"
                                  : "No hay archivo para descargar"
                              }
                            >
                              <i className="fa fa-download"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionsModal;
